module.exports = {"product":{"startingPrice":"From","offer":"Gift","book":"Book"},"products":{"noResult":"No activities matching your search."}}